import { FileListItem } from "../Components/fileList/fileList"

type convertXMLOutputType = {
    FileListItem: FileListItem
}

export function convertXMLtoJSON<T extends keyof convertXMLOutputType>(xmlData: Element, initObj: convertXMLOutputType[T]): convertXMLOutputType[T] {
    const attributes = xmlData.getAttributeNames();
    const record = deepCopy(initObj)
    attributes.forEach(element => {
        record[element] = xmlData.getAttribute(element)
    });
    return record;
}

export function deepCopy(obj) {
    let copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (let i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (let attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = deepCopy(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}
